  const DesignationOptions = [
    // Junior Roles
    'Junior Frontend Developer',
    'Junior Backend Developer',
    'Junior Full Stack Developer', 
    'Junior Mobile App Developer',
    'Junior React Developer',
    'Junior Node.js Developer',
    'Junior Flutter Developer',
    'Junior Android Developer',
    'Junior iOS Developer',

    // Mid/Senior Roles
    'Frontend Developer',
    'Backend Developer', 
    'Full Stack Developer',
    'Mobile App Developer',
    'React Developer',
    'Node.js Developer',
    'Flutter Developer',
    'Android Developer',
    'iOS Developer',
    'Senior Frontend Developer',
    'Senior Backend Developer',
    'Senior Full Stack Developer',
    'Senior Mobile App Developer', 
    'Senior React Developer',
    'Senior Node.js Developer',
    'Senior Flutter Developer',
    'Senior Android Developer',
    'Senior iOS Developer',

    // DevOps & Infra
    'DevOps Engineer',
    'Cloud Engineer',
    'Site Reliability Engineer (SRE)',
    'Infrastructure Engineer', 
    'System Administrator',

    // Design
    'UI Designer',
    'UX Designer',
    'Product Designer',
    'Graphic Designer',
    'Senior UI/UX Designer',

    // Testing & QA
    'Tester',
    'Manual QA Engineer',
    'Automation QA Engineer',
    'Quality Assurance Lead',
    'Junior Manual Tester',

    // Product & Project
    'Project Manager',
    'Product Manager',
    'Scrum Master',
    'Business Analyst',

    // Leadership
    'Tech Lead',
    'Team Lead',
    'Engineering Manager',
    'CTO',
    'CEO',
    'COO',
    'Head of Engineering',
    'Head of Product',

    // Miscellaneous
    'Intern',
    'Software Architect',
    'Security Engineer',
    'Database Administrator',
    'Technical Support Engineer',
    'API Developer',
    'Integration Engineer',

    // Hr
    'HR Manager',
   
];

export default DesignationOptions;
